import type { FaireProductEntity } from "../../entity_types/product";

export const p_5g7f19qx: FaireProductEntity = {
  token: "p_5g7f19qx",
  type: "product",
  name: "I'll Be Brief Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/e222a33b7109eacd44826b29a9e52773c5e1c2bf118f9a90e4cfb7cb986a13c7/1528334993.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/1ce1ac314737e3927f735341c839235a4d5bb697f02cbcc99930534005a421ab/1528334993.png",
    "https://cdn.faire.com/fastly/372273c8c76e4d609bd66e7ae17129709d824886cb5efc3bae1ba73b8459b738.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:24.036Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
